import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-medium-emphasis" }, " Adja meg fiókja email címét, és küldünk egy linket, amellyel új jelszót adhat meg. ", -1)

import AuthLayout from "@/components/layout/AuthLayout.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { PasswordResetService } from "@/services/PasswordResetService";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordView',
  setup(__props) {

const route = useRoute();
const passwordResetService = new PasswordResetService();
const { showToast } = useToast();

const email = ref("");
const sent = ref(false);
const submitting = ref(false);
const formRef = ref<{ validate: () => Promise<{ valid: boolean }> } | null>(
  null
);

// Admins arrive here from /admin/login and have to go back to their own login page.
const loginPath = computed(() =>
  route.query.admin !== undefined ? "/admin/login" : "/login"
);

const rules = {
  required: (v: string) => !!v?.trim() || "Kötelező mező",
  email: (v: string) => /.+@.+\..+/.test(v ?? "") || "Érvénytelen email cím",
};

async function submit() {
  const { valid } = await formRef.value!.validate();
  if (!valid) return;

  submitting.value = true;
  try {
    await passwordResetService.requestReset(email.value.trim());
    sent.value = true;
  } catch (e: any) {
    if (e?.response?.status === 429) {
      showToast(
        "Túl sok próbálkozás. Kérjük, várjon néhány percet, majd próbálja újra.",
        "error"
      );
    } else {
      showToast(
        "A kérés elküldése sikertelen. Kérjük, próbálja újra.",
        "error"
      );
    }
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AuthLayout, { "max-width": 480 }, {
    default: _withCtx(() => [
      (sent.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              color: "success",
              size: "56",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-email-check-outline")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_title, { class: "justify-center mb-2" }, {
              default: _withCtx(() => [
                _createTextVNode("Ellenőrizze postafiókját")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Ha ehhez az email címhez tartozik fiók, elküldtük a jelszó visszaállításához szükséges linket. A link 1 óráig érvényes. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "tonal",
              to: loginPath.value,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Vissza a bejelentkezéshez")
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_card_title, { class: "mb-2" }, {
              default: _withCtx(() => [
                _createTextVNode("Elfelejtett jelszó")
              ]),
              _: 1
            }),
            _createVNode(_component_v_form, {
              ref_key: "formRef",
              ref: formRef,
              onSubmit: _withModifiers(submit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_v_text_field, {
                      modelValue: email.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      label: "Email cím",
                      type: "email",
                      density: "compact",
                      variant: "outlined",
                      "prepend-inner-icon": "mdi-email-outline",
                      autofocus: "",
                      rules: [rules.required, rules.email]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      to: loginPath.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mégse")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      color: "primary",
                      loading: submitting.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Link küldése")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ], 64))
    ]),
    _: 1
  }))
}
}

})